/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Get_In_TouchInputs */

const en_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get in Touch`)
};

const es_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponte en contacto`)
};

const fr_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre contact`)
};

const de_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt aufnehmen`)
};

const ja_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const zh_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与我们联系`)
};

const ar_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل معنا`)
};

const id_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Kami`)
};

const it_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettiti in Contatto`)
};

const ru_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться`)
};

const pt_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em Contato`)
};

const ko_get_in_touch = /** @type {(inputs: Get_In_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

/**
* | output |
* | --- |
* | "Get in Touch" |
*
* @param {Get_In_TouchInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const get_in_touch = /** @type {((inputs?: Get_In_TouchInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Get_In_TouchInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_get_in_touch(inputs)
	if (locale === "es") return es_get_in_touch(inputs)
	if (locale === "fr") return fr_get_in_touch(inputs)
	if (locale === "de") return de_get_in_touch(inputs)
	if (locale === "ja") return ja_get_in_touch(inputs)
	if (locale === "zh") return zh_get_in_touch(inputs)
	if (locale === "ar") return ar_get_in_touch(inputs)
	if (locale === "id") return id_get_in_touch(inputs)
	if (locale === "it") return it_get_in_touch(inputs)
	if (locale === "ru") return ru_get_in_touch(inputs)
	if (locale === "pt") return pt_get_in_touch(inputs)
	return ko_get_in_touch(inputs)
});